import type { PlanResponseDto } from '@evimo/client/models';

export type PlanRow = Pick<
  PlanResponseDto,
  'id' | 'code' | 'name' | 'priority' | 'active' | 'createdAt'
>;

export const PRIORITY_COLOR: Record<string, string> = {
  HIGH: 'red',
  MEDIUM: 'orange',
  LOW: 'blue',
};
